import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledButton = styled.button`
    border: 0;
    background-color: transparent;
    line-height: 24px;

    > span, > i {
        display: inline-block;
        vertical-align: middle;
    }

    &:focus {
        border: 0;
    }
`;
